// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: "https://belmon-fastapi-test.azure.chevron.com/api",
  ivaapBackendUrl: "https://belmon-fastapi-test.azure.chevron.com",
  apiFailureRetryCount: 3,
  apiFailureRetryDelayInSeconds: 2,
  refreshTokenFailureRetryDelayInSeconds: 10,
  refreshTokenIntervalInMillis: 55 * 60 * 1000,
  calTenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  calClientId: "ea791627-b768-46cf-8456-18af48cbe920",
  pageSizeOptions: [10, 25, 50, 100],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
